import React from 'react';
import { IonButton, IonContent, IonPage, useIonAlert, useIonToast, useIonRouter } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { axius, images, types } from 'utils';
import { IonLoading, Header } from 'components';
import { Button, Form, Input, Select } from 'antd';

import './_styles.scss';

interface Props extends RouteComponentProps, types.StateProps { };
const OrderCancel: React.FC<Props> = props => {

    const row = props._data.order;
    const [form] = Form.useForm();
    const router = useIonRouter();

    const [file, setFile] = React.useState(null);
    const [image, setImage] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const [presentToast] = useIonToast();
    const [presentAlert] = useIonAlert();

    const readImage = (e: any) => {
        let fale = e.target.files[0];
        if (fale) {
            let reader = new FileReader() as any;
            reader.onload = () => {
                setFile(fale);
                setImage(reader.result);
            }
            reader.readAsDataURL(fale);
        }
    }

    const submit = (v: any) => {
        if (file) {
            setLoading(true);
            axius.postFile('upload', { file, folder: 'receipts' }).then((res: types.AxiusResponse) => {
                setLoading(false);
                if (res.status === 200) {
                    v['images'] = res.data[0];
                    submitGo(v);
                } else {
                    presentAlert(res.message);
                }
            });
        } else {
            submitGo(v);
        }
    }

    const submitGo = (v: any) => {
        setLoading(true);
        axius.post(`orders/${row.uuid}/cancellation`, v).then((res: types.AxiusResponse) => {
            if (res.status === 201) {
                presentToast({ message: `You have cancelled this order`, duration: 1500 });
                router.push('orders', 'none', 'replace');
            } else {
                if (res.status === 412) {
                    presentAlert(res.data.join('<br />'));
                } else {
                    presentAlert(res.message);
                }
            }
            setLoading(false);
        });
    }

    return (
        <IonPage id="Orders">
            <Header {...props} title="Cancel Order" />

            <IonContent fullscreen={false}>
                <IonLoading open={loading} onCancel={() => setLoading(false)} />
                <div className="p-4">
                    <div className="fw-600 fs-20 primary"><b>Order #{row.id}</b></div>
                    <div className="fw-600 fs-20 mt-3">Let us know why you are cancelling this order</div>

                    <Form form={form} layout="vertical" onFinish={submit} className="mt-4">
                        <Form.Item label="Reason" name="reason" rules={[{ required: true, message: 'Field is required' },]}>
                            <Select size="large" placeholder="Select Reason">
                                {['Customer rejected order', 'Customer unreachable'].map(reason => (
                                    <Select.Option key={reason} value={reason}>{reason}</Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="Additional details:" name="description" rules={[{ required: false, message: 'Field is required' },]}>
                            <Input.TextArea size="large" rows={3} className="primary" />
                        </Form.Item>
                        <Form.Item label="Upload file(s), if any.">
                            <label id="Upload" className="text-center" htmlFor="upload_file">
                                <input type="file" accept={'image/*'} id="upload_file" className="hide" onChange={readImage} />
                                <img src={images.Upload} alt="Upload" height={35} />
                                <div className="small mt-2">Click here to upload</div>
                            </label>
                        </Form.Item>
                        {image && <div className="bg-img rounded" style={{ backgroundImage: `url(${image})` }} />}
                        <p>&nbsp;</p>

                        <Button htmlType="submit" className="hide">Submit</Button>
                        <IonButton expand="block" size="large" type="submit" color="primary" className="animate__animated animate__fadeIn">Submit</IonButton>
                    </Form>
                </div>
            </IonContent>
        </IonPage>
    );
}

export default OrderCancel;